import { useParams } from 'react-router-dom'

import { ProcessesProcessCategoryEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

export const useProcessOverviewTitle = () => {
  const { category } = useParams()

  const titleByType = {
    onboarding: i18n.t('processes.materialize_process.analytics.pending_processes.onboarding'),
    offboarding: i18n.t('processes.materialize_process.analytics.pending_processes.offboarding'),
    custom: i18n.t('processes.materialize_process.analytics.pending_processes.custom'),
    training: i18n.t('processes.materialize_process.analytics.pending_processes.training'),
  }

  const processCategory = category as ProcessesProcessCategoryEnum

  return { title: titleByType[processCategory], category: processCategory }
}
